import React, { useEffect } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getBrowsStudentRequestedListData, getBrowseStudentApprovedListData } from '../../../Redux/action/TutorAction'
import Beatloader from '../../../Common/BeatLoader'

const host = process.env.REACT_APP_API_SERVER
const TutorBrowseStudents = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getBrowsStudentRequestedListData())
        dispatch(getBrowseStudentApprovedListData())
    }, []);

    const {
        loadingBrowseStudentRequestedListApi,
        BrowseStudentRequestedListApiData,
        BrowseStudentRequestedListApiError,


        loadingBrowseStudentApprovedListApi,
        BrowseStudentApprovedListApiData,
        BrowseStudentApprovedListApiError,
    } = useSelector(state => state?.TutorReducer);
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Browse Students
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="browse-students">
                                    <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                <i className="bi bi-file-earmark-person" />
                                                &nbsp;Student Request
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                <i className="bi bi-file-earmark-person" />
                                                &nbsp;Approved Students List
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content my-student-tab-pane" id="myTabContent">

                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingBrowseStudentRequestedListApi ?
                                                <Beatloader />
                                                :
                                                <div className="row">
                                                    {BrowseStudentRequestedListApiData?.length > 0 ?
                                                        BrowseStudentRequestedListApiData?.map((data) => (
                                                            <div className="col-lg-6 col-md-6 my-2">
                                                                <Link
                                                                    to={
                                                                        // data?.status == 'APPROVED' ? `/tutor/my-course-details/${btoa(data?.id)}` :
                                                                        `/tutor/my-session/${btoa(data?.id)}`} state={{ data: data }}
                                                                    className="text-decoration-none text-dark"
                                                                >


                                                                    <div className="card shadow-sm border-0 mb-3">
                                                                        <div className="card-body">
                                                                            {/* Status */}
                                                                            <div className="d-flex justify-content-end mb-2">
                                                                                <span className="badge bg-primary">{data?.status}</span>
                                                                            </div>

                                                                            <div className="row align-items-center">
                                                                                {/* Profile Image */}
                                                                                <div className="col-md-2 text-center">
                                                                                    <img
                                                                                        src={`${host}${data?.student?.profile_img}`}
                                                                                        className="img-fluid rounded-circle shadow-sm"
                                                                                        style={{ height: 80, width: 80, objectFit: "cover" }}
                                                                                        onError={(e) => {
                                                                                            e.target.src = "/assets/img/user/user.png";
                                                                                        }}
                                                                                    />
                                                                                </div>

                                                                                {/* Student & Category Info */}
                                                                                <div className="col-md-5">
                                                                                    <h6 className="mb-1 fw-bold">{data?.student?.name}</h6>
                                                                                    <p className="mb-1 text-muted">{data?.reqCategory?.name}</p>
                                                                                    <p className="mb-1 text-muted">{data?.reqSubCategory?.name}</p>
                                                                                    <p className="mb-0 text-muted">{data?.reqChildSubCategory?.name}</p>
                                                                                </div>

                                                                                {/* Schedule Info */}
                                                                                <div className="col-md-5">
                                                                                    <div className="mb-2">
                                                                                        <small className="text-muted">
                                                                                            <i className="fa-solid fa-calendar-days me-1" />
                                                                                            Schedule Date
                                                                                        </small>
                                                                                        <h6 className="mb-0 text-primary">{data?.format_start_date}</h6>
                                                                                    </div>
                                                                                    <div>
                                                                                        <small className="text-muted">
                                                                                            <i className="fa-solid fa-clock me-1" />
                                                                                            Schedule Time
                                                                                        </small>
                                                                                        <h6 className="mb-0 text-primary">
                                                                                            {data?.time_slot?.formated_start_end_time} (
                                                                                            {data?.time_slot?.timeZoneAbb})
                                                                                        </h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Created At */}
                                                                            <div className="text-center mt-3">
                                                                                <small className="text-muted">
                                                                                    {/* Created At {new Date(data?.createdAt).toDateString()} */}
                                                                                    Created At {new Date(data?.createdAtISO || data?.createdAt.replace(" ", "T")).toDateString()}
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </Link>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}
                                                </div>
                                            }
                                        </div>

                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            {loadingBrowseStudentApprovedListApi ?
                                                <Beatloader />
                                                :
                                                <div className="row">
                                                    {BrowseStudentApprovedListApiData?.length > 0 ?
                                                        BrowseStudentApprovedListApiData?.map((data) => (
                                                            <div className="col-lg-6 col-md-6 my-2" key={data?.id}>

                                                                <Link
                                                                    to={`/tutor/my-course-details/${btoa(data?.id)}`}
                                                                    className="text-decoration-none text-dark"
                                                                    state={{ data: data }}
                                                                >
                                                                      <div className="card shadow-sm border-0 mb-3">
                                                                        <div className="card-body">
                                                                            {/* Status */}
                                                                            <div className="d-flex justify-content-end mb-2">
                                                                                <span className="badge bg-primary">{data?.status}</span>
                                                                            </div>

                                                                            <div className="row align-items-center">
                                                                                {/* Profile Image */}
                                                                                <div className="col-md-2 text-center">
                                                                                    <img
                                                                                        src={`${host}${data?.student?.profile_img}`}
                                                                                        className="img-fluid rounded-circle shadow-sm"
                                                                                        style={{ height: 80, width: 80, objectFit: "cover" }}
                                                                                        onError={(e) => {
                                                                                            e.target.src = "/assets/img/user/user.png";
                                                                                        }}
                                                                                    />
                                                                                </div>

                                                                                {/* Student & Category Info */}
                                                                                <div className="col-md-5">
                                                                                    <h6 className="mb-1 fw-bold">{data?.student?.name}</h6>
                                                                                    <p className="mb-1 text-muted">{data?.reqCategory?.name}</p>
                                                                                    <p className="mb-1 text-muted">{data?.reqSubCategory?.name}</p>
                                                                                    <p className="mb-0 text-muted">{data?.reqChildSubCategory?.name}</p>
                                                                                </div>

                                                                                {/* Schedule Info */}
                                                                                <div className="col-md-5">
                                                                                    <div className="mb-2">
                                                                                        <small className="text-muted">
                                                                                            <i className="fa-solid fa-calendar-days me-1" />
                                                                                            Schedule Date
                                                                                        </small>
                                                                                        <h6 className="mb-0 text-primary">{data?.format_start_date}</h6>
                                                                                    </div>
                                                                                    <div>
                                                                                        <small className="text-muted">
                                                                                            <i className="fa-solid fa-clock me-1" />
                                                                                            Schedule Time
                                                                                        </small>
                                                                                        <h6 className="mb-0 text-primary">
                                                                                            {data?.time_slot?.new_start_date_time}-{data?.time_slot?.new_end_date_time} (
                                                                                            {data?.time_slot?.timeZoneAbb})
                                                                                        </h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Created At */}
                                                                            <div className="text-center mt-3">
                                                                                <small className="text-muted">
                                                                                    {/* Created At {new Date(data?.createdAt).toDateString()} */}
                                                                                    Created At {new Date(data?.createdAtISO || data?.createdAt.replace(" ", "T")).toDateString()}
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorBrowseStudents